module.exports = __webpack_public_path__ + "img/06.c90070ae.jpg";